export const PLATFORMS = {
  android: {
    key: 'android',
    label: 'Android',
    tabLabel: 'Android Apps',
    list: '/api/apps',
    collection: '/api/app',
    item: (appId) => `/api/app/${encodeURIComponent(appId)}`,
    token: (appId) => `/api/app/${encodeURIComponent(appId)}/generate-click-token`,
  },
  ios: {
    key: 'ios',
    label: 'iOS',
    tabLabel: 'iOS Apps',
    list: '/api/apps-ios',
    collection: '/api/app-ios',
    item: (appId) => `/api/app-ios/${encodeURIComponent(appId)}`,
    token: (appId) => `/api/app-ios/${encodeURIComponent(appId)}/generate-click-token`,
  },
};

export const PLATFORM_KEYS = Object.keys(PLATFORMS);

export function getPlatform(key) {
  return PLATFORMS[key] || null;
}

export function isPlatformKey(key) {
  return Object.prototype.hasOwnProperty.call(PLATFORMS, key);
}
